"use client";

import { useEffect, useState } from "react";

import { cn } from "@perceptron/utils/cn";

import { resetDetectAll } from "@demo/libs/detect";

import DetectImageView from "./DetectImageView";
import DetectPanel from "./DetectPanel";

/**
 * Detect mode surface. Desktop: two-panel split — Categories (left, with the
 * examples strip) + image & detections (right).
 */
const DetectSurface = () => {
  const [isFullscreen, setIsFullscreen] = useState(false);

  // Leaving detect fully resets it (image, categories, detections) so nothing
  // bleeds into another mode's shared image/annotation view.
  useEffect(() => {
    return () => {
      resetDetectAll();
    };
  }, []);

  return (
    <div className="relative flex h-full w-full flex-col-reverse gap-2 sm:flex-row sm:gap-3">
      <div className="relative flex h-1/2 min-h-0 w-full pt-2 sm:h-auto sm:w-1/3 sm:shrink-0 sm:pt-0">
        <DetectPanel />
      </div>
      <div
        className={cn(
          "absolute inset-0 z-50 w-full overflow-hidden transition-all duration-300 ease-in-out sm:relative",
          {
            "h-full": isFullscreen,
            "h-1/2 sm:h-full": !isFullscreen,
          },
        )}
      >
        <DetectImageView isFullscreen={isFullscreen} setIsFullscreen={setIsFullscreen} />
      </div>
    </div>
  );
};

export default DetectSurface;
